/**
 * Accordions
 */

function initAccordions() {
    $('.accordion__title').on('click', function(e) {
        e.preventDefault();
    
        const parent = $(this).parent();
        if (parent.hasClass('is-active')) {
            parent.removeClass('is-active');
            
            $('.accordion__content').slideUp();
        } else {
            $('.accordion__item').removeClass('is-active');
            parent.addClass('is-active');
    
            $('.accordion__item:not(.is-active) .accordion__content').slideUp();
            parent.find('.accordion__content').slideDown();
        }
    })

    $('.js-sidebar-filter-toggle').on('click', function(e) {
        e.preventDefault();

        $(this).parent().find('.js-sidebar-filter-content').slideToggle();
        $(this).parent().find('.c-filter-sidebar-option-icon').toggleClass('active');
    })
}